import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

const LanguagesProvider = ({ langsReducer, children }) => {
  const { langJson, locale } = langsReducer;

  return (
    <IntlProvider
      locale={locale.iso}
      defaultLocale={locale.iso}
      messages={langJson[locale.iso]}
    >
      {children}
    </IntlProvider>
  );
};
const mapStateToProps = (state) => ({
  langsReducer: state.languageProviderReducer,
});
export default connect(mapStateToProps, null)(LanguagesProvider);
